import { FC } from "react";
import classNames from "classnames";
import { AccountingMigrationExternalSystem } from "@common/types/domains/accounting/accountingMigration";
import { HStack } from "@design-system/HStack/HStack";
import { VStack } from "@design-system/VStack/VStack";
import styles from "./ExternalSystemGrid.module.scss";
import {
    EXTERNAL_SYSTEM_OPTIONS,
    ExternalSystemIcon,
    PICKABLE_EXTERNAL_SYSTEM_OPTIONS,
    getExternalSystemLabel,
    toExternalSystemChoice,
} from "./externalSystemOptions";

interface Props {
    onSelect: (system: AccountingMigrationExternalSystem | null) => void;
    // When true, always render every system (even flag-gated ones). Used by the
    // migration modal, which handles unsupported systems with a coming-soon step.
    showAllSystems?: boolean;
    className?: string;
}

export const ExternalSystemGrid: FC<Props> = ({
    onSelect,
    showAllSystems = false,
    className,
}) => {
    const visibleOptions = showAllSystems
        ? EXTERNAL_SYSTEM_OPTIONS
        : PICKABLE_EXTERNAL_SYSTEM_OPTIONS;

    return (
        <VStack
            className={classNames(styles.externalSystemsContainer, className)}
        >
            {visibleOptions.map(({ system, institution }) => (
                <HStack
                    gap={8}
                    padding={16}
                    align="center"
                    key={toExternalSystemChoice(system)}
                    className={styles.externalSystemOption}
                    onClick={() => onSelect(system)}
                    tabIndex={0}
                    role="button"
                >
                    <ExternalSystemIcon institution={institution} />
                    <div className={styles.externalSystemLabel}>
                        {getExternalSystemLabel(system)}
                    </div>
                </HStack>
            ))}
        </VStack>
    );
};
